import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(2),
    backgroundColor: '#f78e1e',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(2),
  },
  topFormControl: {
    height: '100%',
    minWidth: 395,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  formControl: {
    height: '100%',
    minWidth: '395px',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  select: {
    padding: theme.spacing(1),
  },
  menuItem: {
    margin: theme.spacing(3, 0),
  },
  submit: {
    margin: theme.spacing(1, 0, 2),
    backgroundColor: '#003767',
    '&:hover': {
      backgroundColor: '#f78e1e',
    },
  },
}));

export default useStyles;
